import React from 'react';
import usePermissions from './usePermissions';

export type RequiredType = 'all' | 'any';

interface RequirePermissionsProps {
  children: React.ReactNode;
  unavailable?: React.ReactNode;
  permissions: string[];
  permissionsMatch?: RequiredType;
}

const RequirePermissions: React.FC<RequirePermissionsProps> = ({
  children,
  permissions,
  permissionsMatch = 'all',
  unavailable = null,
}) => {
  const hasRequiredPermissions = usePermissions(permissions, permissionsMatch);

  return hasRequiredPermissions ? <>{children}</> : <>{unavailable}</>;
};

export default RequirePermissions;
